<template>
    <Breadcrumbs main="Charts" title="Apex Chart" />
    <div class="container-fluid">
        <div class="row">
            <apexCharts />

        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'

const apexCharts = defineAsyncComponent(() => import("@/components/theme/charts/apexChart/apexCharts.vue"))

</script>